import React from 'react'

const Menu = () => <svg className="nav-icon" style={{ height: "inherit" }} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><path d="M41 27H7c-1.7 0-3-1.3-3-3s1.3-3 3-3h34c1.7 0 3 1.3 3 3s-1.3 3-3 3zM41 10H7c-1.7 0-3-1.3-3-3s1.3-3 3-3h34c1.7 0 3 1.3 3 3s-1.3 3-3 3zM41 44H7c-1.7 0-3-1.3-3-3s1.3-3 3-3h34c1.7 0 3 1.3 3 3s-1.3 3-3 3z"/></svg>

export default Menu